import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingIPTR,
    getIPTRById,
    deleteIPTR,
    saveOrUpdateIPTR
} from 'app/services/InsurancePaymentTypeRateService';

import { InsurancePaymentRate } from "app/common/Model/InsurancePaymentRate";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class IPTRStore {
    listAllIPTR = [];
    searchIPTR = new SearchObject();
    pageIPTR = null;
    selectedIPTR = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllIPTR = () => {
        if (this.listAllIPTR?.length === 0 || this.recentlyUpdated) {
            pagingIPTR({ pageIndex: 1, pageSize: PAGESIZE_ALL })
                .then(({ data }) => {
                    this.listAllIPTR = data?.content || [];
                    this.recentlyUpdated = false;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy loại mức hưởng BHYT có lỗi");
                })
        }
    }

    pagingIPTR = () => {
        pagingIPTR(this.searchIPTR).then(({ data }) => {
            this.pageIPTR = data;
        })
    }

    handleChangeFormSearch = (searchIPTR) => {
        this.searchIPTR = checkSearchObject(this.searchIPTR, searchIPTR);
        this.pagingIPTR();
    }

    handleOpenFormCreateOrEdit = (iptrId) => {
        if (Boolean(iptrId)) {
            getIPTRById(iptrId).then(({ data }) => {
                this.selectedIPTR = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedIPTR = new InsurancePaymentRate();
            this.openFormCreateOrEdit = true;
        }
    }

    saveIPTR = async (iptr, { setSubmitting }) => {
        return await saveOrUpdateIPTR(iptr).then(() => {
            this.selectedIPTR = null;
            toast.success("Lưu loại mức hưởng BHYT thành công!");
            this.pagingIPTR();
            this.handleClosePopup();
            this.recentlyUpdated = true;
            this.listAllIPTR = [];
        }).catch(function (error) {
            toast.error("Lưu loại mức hưởng BHYT thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteIPTR = (iptr) => {
        this.selectedIPTR = { id: iptr?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDeleteIPTR = () => deleteIPTR(this.selectedIPTR?.id)
        .then(() => {
            if (this.searchIPTR?.pageIndex > 1 && this.pageIPTR?.content?.length === 1) {
                this.searchIPTR.pageIndex -= 1;
            }
            toast.success("Xóa loại mức hưởng BHYT thành công!");
            this.pagingIPTR();
            this.recentlyUpdated = true;
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa loại mức hưởng BHYT thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchIPTR = new SearchObject();
        this.pageIPTR = null;
        this.selectedIPTR = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }
}